module.exports = __webpack_public_path__ + "img/EBADGE.1e03223b.png";